import { render, staticRenderFns } from "./VQuestionnaire.vue?vue&type=template&id=2666100b&"
import script from "./VQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./VQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./VQuestionnaire.vue?vue&type=style&index=0&id=2666100b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports